import { render } from "./RoundedIconAndText.vue?vue&type=template&id=38a7854b&scoped=true&ts=true"
import script from "./RoundedIconAndText.vue?vue&type=script&lang=ts"
export * from "./RoundedIconAndText.vue?vue&type=script&lang=ts"

import "./RoundedIconAndText.vue?vue&type=style&index=0&id=38a7854b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a7854b"]])

export default __exports__